<section>
  <plants-jumbotron
    [altImageText]="altImageText"
    [imageUrl]="imageUrl"
    [commonName]="commonName"
    [scientificName]="scientificName"
    (routeToProfile)="routeToProfile()"
  ></plants-jumbotron>
</section>
@defer {
  <section class="margin-top-5">
    <div class="grid-row grid-gap">
      <div class="tablet:grid-col-12">
        <div class="usa-card">
          <div class="usa-card__container">
            <div class="usa-card__body">
              <div class="overflow-hidden text-center">
                <img
                  ngSrc="../../images/welcome_slim.jpg"
                  class="maxw-none"
                  alt="spoonleaf sundew"
                  width="892"
                  height="241"
                  priority
                />
              </div>
              <h3>New PLANTS Website</h3>
              <p>
                Welcome to the new PLANTS website! Information on the new website can be found in
                the
                <a class="usa-link" [routerLink]="['/help']">What is PLANTS</a>
                section. Additional releases will be forthcoming. For questions or concerns please
                <a class="usa-link" href="mailto:plants@ftc.usda.gov">contact us</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-row grid-gap">
      <div class="tablet:grid-col-6">
        <div class="usa-card">
          <div class="usa-card__container">
            <div class="usa-card__body card-min-height">
              <div class="overflow-hidden text-center">
                <a
                  class="usa-link"
                  [routerLink]="['/wetland-search']"
                  title="External, opens in a new tab. Aerial of wetlands in Butte County, California"
                >
                  <img
                    class="maxw-none"
                    ngSrc="../../images/wetland_web-min.jpg"
                    alt="External, opens in a new tab. Aerial of wetlands in Butte County, California"
                    width="366"
                    height="244"
                  />
                </a>
              </div>
              <h3>2020 National Wetland Plant List</h3>
              <p>
                The wetland indicator status ratings from the 2020
                <a class="usa-link" [routerLink]="['/wetland-search']"
                  >National Wetland Plant List (NWPL)</a
                >
                effective November 2, 2021, are now on our species profile pages and are fully
                searchable.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="tablet:grid-col-6">
        <div class="usa-card">
          <div class="usa-card__container">
            <div class="usa-card__body card-min-height">
              <div class="overflow-hidden text-center">
                <a
                  class="usa-link"
                  href="{{ nrcsPollinatorUrl }}"
                  target="_blank"
                  title="External, opens in a new tab. NRCS pollinator-related literature and documentation"
                  rel="noopener noreferrer"
                >
                  <img
                    class="maxw-none"
                    ngSrc="../../images/pollinator_web-min.jpg"
                    alt="External, opens in a new tab. NRCS pollinator-related literature and documentation"
                    width="366"
                    height="244"
                  />
                </a>
              </div>
              <h3>NRCS Pollinator Information</h3>
              <p>
                <a
                  class="usa-link usa-link--external"
                  href="{{ nrcsPollinatorUrl }}"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NRCS pollinator-related literature and documentation, </a
                >including
                <a
                  class="usa-link usa-link--external"
                  href="https://directives.nrcs.usda.gov/sites/default/files2/1712940638/35160.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  >190-TN-B-78 (4th edition, June 2023) Pollinator Conservation Farm Bill Programs
                  (2018–2023)</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-row grid-gap">
      <div class="tablet:grid-col-6">
        <div class="usa-card">
          <div class="usa-card__container">
            <div class="usa-card__body card-min-height">
              <div class="overflow-hidden text-center">
                <a
                  href="https://digitalcommons.usu.edu/sagestep_reports/20/"
                  target="_blank"
                  title="External, opens in a new tab. Range cover in the foreground consists of Big Sagebrush with an understory of Bluebunch Wheatgrass and Idaho Fascue. In the background are scattered Ponderosa Pine Trees."
                  rel="noopener noreferrer"
                >
                  <img
                    class="maxw-none"
                    ngSrc="../../images/sagebrush_web-min.jpg"
                    alt="External, opens in a new tab. Range cover in the foreground consists of Big Sagebrush with an understory of Bluebunch Wheatgrass and Idaho Fascue. In the background are scattered Ponderosa Pine Trees."
                    width="366"
                    height="244"
                  />
                </a>
              </div>
              <h3>Pocket Guide to Sagebrush</h3>
              <p>
                Funded partly by the NRCS, a new guide to sagebrush, written by Leila Shultz and
                produced by
                <a
                  class="usa-link usa-link--external"
                  href="https://digitalcommons.usu.edu/sagestep_reports/20/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >SageSTEP</a
                >, is available.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="tablet:grid-col-6">
        <div class="usa-card">
          <div class="usa-card__container">
            <div class="usa-card__body card-min-height">
              <div class="overflow-hidden text-center">
                <a
                  href="https://www.nrcs.usda.gov/plant-materials/common-weedsmalezas-comunes"
                  target="_blank"
                  title="External, opens in a new tab. Common Weeds in Puerto Rico and U.S. Virgin Islands"
                  rel="noopener noreferrer"
                >
                  <img
                    class="maxw-none"
                    ngSrc="../../images/weeds_web-min.jpg"
                    alt="External, opens in a new tab. Common Weeds in Puerto Rico and U.S. Virgin Islands"
                    width="366"
                    height="244"
                  />
                </a>
              </div>
              <h3>Common Weeds in Puerto Rico and U.S. Virgin Islands</h3>
              <p>
                A bilingual guide to the common weeds of Puerto Rico and the U.S. Virgin Islands is
                now available from
                <a
                  class="usa-link usa-link--external"
                  href="https://www.nrcs.usda.gov/plant-materials/common-weedsmalezas-comunes"
                  target="_blank"
                  rel="noopener noreferrer"
                  >NRCS</a
                >.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
}
